<template>
  <q-item
      v-bind="$attrs"
      v-close-popup
      class="nav-list__item"
      :class="{'nav-list__item--with-icon': icon}"
      clickable
      :tag="action ? 'div' : 'a'"
      :target="target"
      :href="action ? null : href ? href : $route(route)"
  >
    <q-item-section avatar v-if="icon">
      <q-icon :name="icon" aria-hidden="true" />
    </q-item-section>
    <q-item-section>
      {{ label }}
    </q-item-section>
  </q-item>
</template>

<script>
export default {
  props: {
    label: {
      type: String,
      default: '',
    },
    icon: {
      type: String,
      default: '',
    },
    route: {
      type: String,
      default: '',
    },
    href: {
      type: String,
      default: '',
    },
    target: {
      type: String,
      default: '_self',
    },
    action: {
      type: Boolean,
      default: false,
    },
  },
}
</script>
